jQuery(document).ready(function ($) {
	$(".custom-cart-block .slider").each(function (index) {
		const $block = $(this);

		// Scope sliders inside this block
		const sliders = [
			$block.find(".why-not-add-slider"),
			$block.find(".consumables-slider"),
		];

		sliders.forEach(function ($slider, sliderIndex) {
			if (!$slider.length || typeof $.fn.slick !== "function") return;

			// Make unique dots container for this slider
			const $controls = $slider.siblings(".controls");
			const $dots = $controls.find(".slide-m-dots");

			// Unique ID for dots
			const uniqueDotsClass = "slide-alt-dots-" + index + "-" + sliderIndex;
			$dots.addClass(uniqueDotsClass);

			// Unique prev/next buttons
			const $prev = $controls.find(".slick-left");
			const $next = $controls.find(".slick-right");

			$slider.slick({
				slidesToShow: 5,
				slidesToScroll: 5,
				arrows: true,
				dots: true,
				infinite: true,
				adaptiveHeight: true,
				appendDots: $dots,
				prevArrow: $prev,
				nextArrow: $next,
				responsive: [
					// {
					// 	breakpoint: 1500,
					// 	settings: { slidesToShow: 3, slidesToScroll: 2 },
					// },
					// {
					// 	breakpoint: 1400,
					// 	settings: { slidesToShow: 2, slidesToScroll: 1 },
					// },
					{
						breakpoint: 1024,
						settings: { slidesToShow: 2, slidesToScroll: 1 },
					},
					{ breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2 } },
					{ breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } },
				],
			});
		});
	});
});
